module.exports = __webpack_public_path__ + "img/xmr.9749f027.svg";